import React, { useContext, useState } from 'react'
import { StoresContext } from '@App/contexts'
import { ICONS, ILLUSTRATIONS } from '@Const/common'
import Button from '@Components/Buttons/Button'
import './index.scss'
interface SongwriterHubWelcomePopupProps {
    onClose(): void
}

const SongwriterHubWelcomePopup = (props: SongwriterHubWelcomePopupProps) => {
    const { onClose } = props
    const [numStep, setNumStep] = useState(1)
    const { userStore } = useContext(StoresContext)

    const goToSongwriter = async () => {
        userStore.changeUserSetting('showSongwriterHubPopup', false)
        onClose()
    }

    return (
        <div className="main-block songwriter-hub-intro">
            <img
                onClick={() => onClose()}
                className={`close ${numStep === 2 ? 'white' : ''}`}
                src={ICONS.close}
                alt="close"
            />
            <div className="welcome-popup">
                {numStep === 1 && (
                    <div className="intro-step">
                        <div>
                            <h3>Welcome to The MLC Songwriter Hub</h3>
                            <p>
                                The MLC Songwriter Hub is your personal dashboard for organizing and confirming details
                                about the songs you’ve written that are listed in The MLC’s Public Works Database.
                            </p>
                        </div>
                        <img src={ILLUSTRATIONS.illustration4} alt="illustration" />
                    </div>
                )}
                {numStep === 2 && (
                    <div className="second-step">
                        <div>
                            <p>
                                The first step is to search for and select all the versions of your writer name you’ve
                                used to start building your catalog.
                            </p>
                            <p>You can come back anytime to search for more songs and keep adding to your catalog.</p>
                        </div>
                        <img src={ILLUSTRATIONS.illustration4} alt="illustration" />
                    </div>
                )}
                <div className="footer-block">
                    <div className="steps">
                        <div
                            className="active"
                            onClick={() => {
                                setNumStep(1)
                            }}
                        />
                        <div
                            className={`${numStep === 2 ? 'active' : ''}`}
                            onClick={() => {
                                setNumStep(2)
                            }}
                        />
                    </div>
                    {numStep === 1 ? (
                        <Button
                            mainColor
                            type="primary"
                            icon={ICONS.arrow_forward}
                            onClick={() => {
                                setNumStep(2)
                            }}
                        >
                            Next
                        </Button>
                    ) : (
                        <Button mainColor type="primary" onClick={goToSongwriter}>
                            Take me to writer search
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}
export default SongwriterHubWelcomePopup
